// extracted by mini-css-extract-plugin
export var box = "_4h-0";
export var check = "_4h-1";
export var checkboxButton = "_4h-6";
export var checkboxGroup = "_4h-5";
export var disabled = "_4h-7";
export var ghost = "_4h-9";
export var input = "_4h-2";
export var label = "_4h-4";
export var normal = "_4h-8";
export var uncheck = "_4h-3";